// client/src/features/salesCoach/components/SalesCoachMain.jsx
import React from "react";
import { useParams } from "react-router-dom";
import RepCatalog from "./RepCatalog";
import RepLearningInterface from "./RepLearningInterface";

const SalesCoachMain = () => {
  const { id } = useParams(); // Selected training ID

  if (id) {
    return <RepLearningInterface id={id} />;
  }

  return <RepCatalog />;
};

export default SalesCoachMain;
